module.exports = __webpack_public_path__ + "img/reset_sensor_step_3.ea8311c8.gif";